import { useEffect, useState } from "react";
import axios from "axios";
import { Col, Container, Row, Image, Tab, Tabs } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Testemonials from "../components/common-components/testmonials";
import HospitalHeader from "../components/HospitalHeader";
import SchoolHeader from "../components/SchoolHeader";
import StudentHeader from "../components/StudentHeader";
import "swiper/css";
import "swiper/css/pagination";

const AboutUs = () => {
    const pageTitle = localStorage.getItem("PageTittle")
    const token = localStorage.getItem("token")
    const BaseURL = process.env.REACT_APP_BASE_URL
    const [aboutUs, setAboutUs] = useState()
    useEffect(() => {
        try {
            axios.get(`${BaseURL}users/get/about/us`).then(res => setAboutUs(res.data.data))

        } catch (error) {
            console.log(error)

        }
    }, [])
    return (
        <div className="about_respnsve">
            {pageTitle === "Hospital" && token && <HospitalHeader />}
            {pageTitle === "School" && token && <SchoolHeader />}
            {pageTitle === "Student" && token && <StudentHeader />}
            {!token && <Header />}
            <section className="bnner_imgswork py-5">
                <div className="cntctbnnr_img text-center">
                    <h1>About Us</h1>
                    <div className="innner_hmm text-center">
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                            <Breadcrumb.Item active>About Us</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </section>

            <section className="whoweare_sctn sctn_pdng">
                <Container>
                    <Row>
                        <Col md={6}>
                            <div className="who_lcntnt">
                                <div className="tstmnl_hdng ">
                                    <h6 className="text_theme">About Us</h6>
                                    <h2>{aboutUs?.who_we_are?.title}</h2>
                                    <p>
                                        {aboutUs?.who_we_are?.description}
                                    </p>

                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="about_whoimg position-relative">
                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${aboutUs?.who_we_are?.image}&type=about_us`} fluid />
                                {/* <Image src={young_beautiful} fluid /> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="all_portl_ftr sctn_pdng">
                <Container>
                    <div className="tstmnl_hdng text-center mxwdth_100">
                        <h6 className="text_theme">Why Choose Us</h6>
                        <h2>{aboutUs?.why_we_are_diff?.title}</h2>
                        <p>
                            {aboutUs?.why_we_are_diff?.description}
                        </p>
                    </div>
                    <div className="prtl_cntnt_wrp">
                        <Tabs
                            defaultActiveKey="school"
                            id="justify-tab-example"
                            className="mb-3 prtl_tabs"
                            justify
                        >
                            <Tab eventKey="school" title="Schools">
                                <div className="prtl_tab_cntnt">
                                    <Row>
                                        <Col md={6}>
                                            <div className="prtl_img">
                                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${aboutUs?.school?.image}&type=about_us`} fluid />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="prtl_txt">
                                                <h4 className="text_theme mb-4">
                                                    {aboutUs?.school?.title}
                                                </h4>
                                                <div className="CheckFine"
                                                    dangerouslySetInnerHTML={{ __html: aboutUs?.school?.description }}
                                                />

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Tab>
                            <Tab eventKey="student" title="Students">
                                <div className="prtl_tab_cntnt">
                                    <Row>
                                        <Col md={6}>
                                            <div className="prtl_txt">
                                                <h4 className="text_theme mb-4">
                                                    {aboutUs?.student?.title}
                                                </h4>

                                                <div className="CheckFine"
                                                    dangerouslySetInnerHTML={{ __html: aboutUs?.student?.description }}
                                                />

                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="prtl_img">
                                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${aboutUs?.student?.image}&type=about_us`} fluid />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Tab>
                            <Tab eventKey="longer-tab" title="Hospitals">
                                <div className="prtl_tab_cntnt">
                                    <Row>
                                        <Col md={6}>
                                            <div className="prtl_img">
                                                <Image src={`${process.env.REACT_APP_BASE_URL}admin/getImage?document=${aboutUs?.hospital?.image}&type=about_us`} fluid />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="prtl_txt">
                                                <h4 className="text_theme mb-4">
                                                    {aboutUs?.hospital?.title}
                                                </h4>
                                                <div className="CheckFine"
                                                    dangerouslySetInnerHTML={{ __html: aboutUs?.hospital?.description }}
                                                />

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </Container>
            </section>

            <section className="clnt_tstmnls">
               <Testemonials/>
            </section>

            <Footer />
        </div>
    );
};
export default AboutUs;
